import Dexie from "dexie";

export const db = new Dexie("CrossTracksDB");

db.version(1).stores({
  offlineService: "id, band_id, sdate, servicetitle",
  offlineSongs: "songid, title, artist, skey, chordpro, url, track, order",
  meta: "key, value",
});

export default db;
